const PAGE_INSTRUCTIONS_UPDATED = 'PAGE_INSTRUCTIONS_UPDATED';

export const dispatchUpdatedPageInstructions = (payload) => ({
  type: PAGE_INSTRUCTIONS_UPDATED,
  payload,
});
